<p>edit-whitelist-entry-component works!</p>
